const $ = jQuery.noConflict();

function borderAnimation() {
	const blockHeroDisplay = document.querySelector('.block-hero-display');
	if (blockHeroDisplay) {
		const borderAnimationWrappers = blockHeroDisplay.querySelectorAll(".border-animation-wrapper");
		document.body.classList.add('hero-display-initial-animation');
		blockHeroDisplay.classList.add('initial-animation');

		const timeout = setTimeout(() => {
			for (let i = 0; i < borderAnimationWrappers.length; i++) {
				const borderAnimationWrapper = borderAnimationWrappers[i];
				borderAnimationWrapper.classList.add("initial-animation");
			}

			clearTimeout(timeout);
		}, 1);
	}
}

function heroDisplayMain() {
	const self = this;

	self.rootBlock = null;
	self.targetBlock = null;
	self.observer = null;
	self.config = {
		attributes: true,
		childList: true,
		subtree: true
	};

	function getRootBlock() {
		const rootBlock = document.querySelector('.block-hero-display');
		if (rootBlock) self.rootBlock = rootBlock;
	}

	function getElements() {
		const targetBlock = self.rootBlock.querySelector('.slick-track');
		if (targetBlock) self.targetBlock = targetBlock;
	}

	self.setHeight = () => {
		const slide = self.targetBlock.querySelector('.slick-current');

		if (slide) {
			self.rootBlock.style.removeProperty('height');

			if (matchMedia("(max-width: 768px)").matches) {
				self.rootBlock.style.height = `${slide.offsetHeight}px`;
			} else {
				self.rootBlock.style.removeProperty('height');
			}
		}
	}

	self.callback = function(mutationList) {
		mutationList.forEach(() => {
			self.setHeight();
		});
	};

	self.startObserver = function() {
		self.observer = new MutationObserver(self.callback);
		self.targetBlock?.childNodes.forEach((child) => {
			self.observer.observe(child, self.config);
		});
	}

	self.init = () => {
		getRootBlock();
		getElements();
		self.setHeight();
	};

	return this;
}

function slickHandler() {
	const $initialCurrentSlide = $('.block-hero-display .component-slider .slick-current');

	$initialCurrentSlide.find('.block-hero-display-slide__content').addClass('active');
	$initialCurrentSlide.find('.image-wrapper img').addClass('active');

	$('.block-hero-display .component-slider').on('beforeChange', function(event, slick, currID, nextID) {
		const $nextSlide = $(slick.$slides[nextID]);

		$(slick.$slides).each(function() {
			const $slide = $(this);

			if ($slide.is($nextSlide)) {
				$slide.find('.block-hero-display-slide__content').addClass('active');
				$slide.find('.image-wrapper img').addClass('active');
			} else {
				$slide.find('.image-wrapper img').removeClass('active');
				$slide.find('.block-hero-display-slide__content').removeClass('active');
			}
		});
	});
}

function heroDisplayA11Y() {
	const allSlides = document.querySelectorAll('.block-hero-display .component-slider .slick-slide');

	allSlides.forEach((slide) => {
		const focusables = slide.querySelectorAll('a[href]');

		if (slide.getAttribute('aria-hidden') === 'true') {
			focusables.forEach((focusable) => {
				focusable.setAttribute('tabindex', '-1');
			});
		} else {
			focusables.forEach((focusable) => {
				focusable.removeAttribute('tabindex');
			});
		}
	});

	$('.block-hero-display .component-slider').on('afterChange', function(event, slick, currID) {
		const $curSlide = $(slick.$slides[currID]);

		$(slick.$slides).each(function() {
			const $slide = $(this);
			const focusables = $slide.find('a[href]');

			if ($slide.is($curSlide)) {
				focusables.each(function() {
					$(this).attr('tabindex', '0');
				});
			} else {
				focusables.each(function() {
					$(this).attr('tabindex', '-1');
				});
			}
		});
	});
}

const heroDisplayClass = new heroDisplayMain();

document.addEventListener('DOMContentLoaded', () => {
	heroDisplayA11Y();
});

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		borderAnimation();
		heroDisplayClass.init();
		heroDisplayClass.startObserver();
		slickHandler();
	},
	resized() {
		heroDisplayClass.setHeight();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
